import * as React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';

import Colors from '../constants/Colors'
import FontStyles from '../constants/FontStyle';

function IconImage({ name, isActive }) {
  if (isActive) {
    name = name + '-active'
  }
  let output = null
  switch (name) {
    case 'home':
      output = <Image source={require('../assets/images/main/tab-home-icon.png')} style={styles.imageIcon} />
      break;
    case 'home-active':
      output = <Image source={require('../assets/images/main/tab-home-icon-active.png')} style={styles.imageIcon} />
      break;
    case 'products':
      output = <Image source={require('../assets/images/main/tab-orders-icon.png')} style={styles.imageIcon} />
      break;
    case 'products-active':
      output = <Image source={require('../assets/images/main/tab-orders-icon-active.png')} style={styles.imageIcon} />
      break;
    case 'cart':
      output = <Image source={require('../assets/images/main/tab-cart-icon.png')} style={styles.imageIcon} />
      break;
    case 'cart-active':
      output = <Image source={require('../assets/images/main/tab-cart-icon-active.png')} style={styles.imageIcon} />
      break;
    case 'settings':
      output = <Image source={require('../assets/images/main/tab-gear-icon.png')} style={styles.imageIcon} />
      break;
    case 'settings-active':
      output = <Image source={require('../assets/images/main/tab-gear-icon-active.png')} style={styles.imageIcon} />
      break;
    case 'invoices':
      output = <Image source={require('../assets/images/main/tab-invoices-icon.png')} style={styles.imageIcon} />
      break;
    case 'invoices-active':
      output = <Image source={require('../assets/images/main/tab-invoices-icon-active.png')} style={styles.imageIcon} />
      break;
    case 'account':
      output = <Image source={require('../assets/images/main/tab-account-icon.png')} style={styles.imageIcon} />
      break;
    case 'account-active':
      output = <Image source={require('../assets/images/main/tab-account-icon-active.png')} style={styles.imageIcon} />
      break;

    default:
      break;
  }
  return output
}

export default function TabBarIcon(props) {
  return (
    <View style={styles.container}>

      <IconImage name={props.name} isActive={props.focused} />

      {
        props.badgeCount
        && <View style={styles.badgeDot}></View>
        // && <View style={styles.badgeContainer}>
        //   <Text style={styles.badgeNumber}>{props.badgeCount}</Text>
        // </View>
      }
    </View>
  );
}


const styles = StyleSheet.create({
  container: {
    position: 'relative',
    margin: 0,
    padding: 0,
    maxHeight: 24
  },
  imageIcon: {
    width: 24,
    height: 24,
    maxHeight: 24,
  },
  badgeContainer: {
    position: 'absolute',
    top: 0, left: '50%',
    marginLeft: 10,
    padding: 2,
    borderRadius: 2,
    height: 14,
    backgroundColor: Colors.redColor,
    paddingHorizontal: 4,
    paddingVertical: 2,
  },
  badgeDot: {
    position: 'absolute',
    top: 0, left: '50%',
    marginLeft: 10,
    borderRadius: 6,
    width: 6,
    height: 6,
    backgroundColor: Colors.redColor,
  },
  badgeNumber: {
    color: '#FFFFFF',
    ...FontStyles.size8,
    ...FontStyles.lh10,
    ...FontStyles.bold,
    textAlign: 'center',
    textAlignVertical: 'center',
  }
})